/* SummaryCards styles - extracted from Attorney.module.css */

/* ============================================
   CARDS WRAPPER
   ============================================ */
.cardsWrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: auto;
  gap: 12px;
  align-items: flex-end;
}

/* ============================================
   SUMMARY CARD
   ============================================ */
.card {
  display: flex;
  border: 1px solid var(--border);
  border-radius: 10px;
  height: auto;
  min-height: 88px;
  flex: 1 1 0;
  min-width: 300px;
  background: var(--background);
  color: var(--foreground);
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}

:global(.dark) .card {
  border: 1px solid var(--border);
  background-color: var(--card);
  color: var(--foreground);
}

/* Inline variant: used for Calendar view's single month summary */
.cardInline {
  flex: 0 0 auto;
  width: fit-content;
  max-width: 100%;
}

/* ============================================
   CARD BLOCK (Day / Week / Month sections)
   ============================================ */
.block {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--border);
  gap: 4px;
  padding-left: 12px;
}

:global(.dark) .block {
  border-right: 1px solid var(--border);
}

/* Remove border from the last block */
.block:last-child {
  border-right: none;
}

/* ============================================
   TEXT STYLES
   ============================================ */
.dateText {
	width: 100%;
	display: flex;
	justify-content: left;
	align-items: center;
	font-size: 0.75rem;
	font-weight: 600;
	letter-spacing: 0.03em;
	text-transform: uppercase;
	color: var(--muted-foreground);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-height: 18px;
}

.textRow {
	width: 100%;
	display: flex;
	justify-content: left;
	align-items: center;
	font-size: 0.875rem;
	font-weight: 400;
	min-height: 20px;
}

/* ============================================
   MOBILE RESPONSIVE
   ============================================ */
@media screen and (max-width: 750px) {
  .cardsWrapper {
    display: flex;
    width: 100% !important;
  }

  .card {
    min-width: 0 !important;
    width: 100% !important;
  }
}
